import {Component, Inject, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {HeaderComponent} from "./components/header/header.component";
import {FooterComponent} from "./components/footer/footer.component";
import {AuthService} from "./auth/auth.service";
import {SessionService} from "./services/session/session.service";
import {catchError, interval, Observable, share, startWith, Subscription, switchMap, throwError} from "rxjs";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {ImageService} from "./services/image/image.service";
import {Platform} from "@angular/cdk/platform";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  subscriptions = new Subscription();

  constructor(private sessionService: SessionService, private imageService: ImageService, @Inject(PLATFORM_ID) private platform: Platform) {}

  ngOnInit(): void {
    this.getSessionData();

    // if (isPlatformBrowser(this.platform)) {
    //   const sub = interval(10000).pipe(
    //     startWith(0),
    //     switchMap(() => this.imageService.getRandomImageWithTags())
    //   ).subscribe();
    //
    //   this.subscriptions.add(sub);
    // }
    //this.showMessage(error.error.error.message);
  }

  getSessionData(): void {
    const sub = this.sessionService.getSessionData().pipe(
      catchError(this.handleError),
    ).subscribe();

    this.subscriptions.add(sub);
  }

  private handleError(error: any) {
    console.error('An error occurred', error);
    return throwError(error);
  }

}
